import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { INTERCEPTOR_BLOCK_ERROR } from '../constants/texts';
import logout from './logout';

export const onFullfilled = (response: AxiosResponse) =>
  // Interceptor handling a successful response
  response;

export type Response = {
  errors: { message: string }[];
};

const isBlockedBySessionTimeout = (error: AxiosError<Response>): boolean =>
  error instanceof Error && error.message === INTERCEPTOR_BLOCK_ERROR;

export const onRejected = async (error: AxiosError<Response>) => {
  // Silently swallow errors from intentionally blocked requests during session timeout so no technical message reaches the UI.
  if (isBlockedBySessionTimeout(error)) {
    return new Promise(() => {});
  }

  if (
    !error.config ||
    !error.response ||
    error.response?.status !== 401 ||
    error.response.data?.errors?.length
  ) {
    return Promise.reject(error);
  }

  const url = `${error.config?.baseURL}${error.config?.url}`;

  if (!url.includes('aula.education') || url.includes('/auth/logout')) {
    return Promise.reject(error);
  }

  await logout({ returnAfterLogin: true, makeLogoutApiCall: false });

  return Promise.reject(error);
};

export default (instance: AxiosInstance) => {
  (instance || axios).interceptors.response.use(onFullfilled, onRejected);
};
